<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('distributor_edit')" >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-account-child</v-icon>{{ item['name'] }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-distributor-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('qualitycheck.distributor.name') }}</strong></td>
              <td>
                                    {{ item['name'] }}
              </td>
              <td><strong>{{ $t('qualitycheck.distributor.emailsupport') }}</strong></td>
              <td>
                                    {{ item['emailSupport'] }}
              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('qualitycheck.distributor.comment') }}</strong></td>
              <td>
                                    {{ item['comment'] }}
              </td>

              <td></td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <template>
        <div class="distributor-list">
          <Toolbar />

          <v-container grid-list-xl fluid>
            <v-layout row wrap>
              <v-flex sm12>
                <h1><v-icon large>mdi-account-cash</v-icon>{{$t('qualitycheck.customer.customers')}}</h1>
              </v-flex>
              <v-flex lg12>
                <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
                  <CustomerFilterForm
                    ref="filterForm"
                    :values="filters"
                    slot="filter"
                  />
                </DataFilter>

                <br />

                <v-data-table
                  v-model="selected"
                  :headers="headers"
                  :items="items"
        :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
                  :loading="isLoading"
                  :loading-text="$t('global.loading')"
                  :options.sync="options"
                  :server-items-length="totalItems"
                  class="elevation-1"
                  item-key="@id"
                  @update:options="onUpdateOptions"
                  @click:row="showHandlerSub"
@contextmenu:row="showHandlerSubExt"
                >
                <template slot="item.tags" slot-scope="{ item }">
                  <div id="tags">
                  <v-chip v-for="tag in item['tags']" :key="tag.id"
                    class="ma-1 font-weight-bold"

                    color="secondary"
                  >
                    {{ tag.name }}
                  </v-chip>
                </div>
                </template>


                  <ActionCell
                    slot="item.action"
                    slot-scope="props"
                    :handle-show="() => showHandlerSub(item,'Customer',props.item)"
                  ></ActionCell>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
      </template>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import CustomerFilterForm from '../../components/customer/Filter';
import DataFilter from '../../components/DataFilter';


const servicePrefix = 'Distributor';

export default {
  name: 'DistributorShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar,
      ActionCell,
      CustomerFilterForm,
      DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('qualitycheck.customer.name'), value: 'name' },
        { text: this.$t('ticket.tags'), value: 'tags' },

        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      filters: {
        'distributor' : this.$route.params.id,
      },
      selected: []
    };
  },
  mixins: [ShowMixin,AccessMixin,ListMixin],
  computed: {
    ...mapFields('distributor', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('distributor', ['find']),
    ...mapGetters('customer', {
      items: 'list'
    }),
    ...mapFields('customer', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('distributor', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    }),
    ...mapActions('customer', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
